import type { FC } from 'react';
import React from 'react';
import { styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import Box from '@atlaskit/primitives/box';
import { xcss } from '@atlaskit/primitives/xcss';

import { ContentStateColor } from '../ContentStateColor.tsx';

import type { ContentStateProps } from './types.ts';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ContentStateWrapper = styled.button({
	display: 'flex',
	alignItems: 'center',
	cursor: 'pointer',
	height: '36px',
	width: '100%',
	backgroundColor: token('color.background.neutral.subtle'),
	padding: 0,
	font: token('font.body'),
	color: token('color.text'),
	outlineColor: token('color.border.brand'),
	border: 'none',
	'&:hover': {
		backgroundColor: token('color.background.neutral'),
	},
	'&:disabled': {
		cursor: 'not-allowed',
		opacity: 0.7,
		backgroundColor: 'transparent',
	},
});

const contentStateNameStyles = xcss({
	textOverflow: 'ellipsis',
	overflowX: 'hidden',
	whiteSpace: 'nowrap',
});

export const ContentState: FC<ContentStateProps> = ({ contentState, onClick, userOffline }) => {
	return (
		<ContentStateWrapper data-testid="content-state" onClick={onClick} disabled={userOffline}>
			<ContentStateColor
				dataTestId="content-state-color"
				appearance="editorContentState"
				color={contentState.color}
				restrictionLevel={contentState.restrictionLevel}
			/>
			<Box xcss={[contentStateNameStyles]}>{contentState.name}</Box>
		</ContentStateWrapper>
	);
};
